const dealerInkedPrice = 5
const dealerPrice = 5 // 5
const originalDealerPrice = 5
const privatePrice = 10 // 10
const originalPrivatePrice = 10
const promoPrice = 0
const specialPrice = 1

module.exports = {
    dealerInkedPrice,
    dealerPrice,
    privatePrice,
    promoPrice,
    specialPrice,

    originalDealerPrice,
    originalPrivatePrice,
}